import type { OIDCDiscovery } from "./types"

const CACHE_TTL = 60 * 60 * 1000 // 1 hour
const discoveryCache = new Map<string, { discovery: OIDCDiscovery; cachedAt: number }>()

/** Normalize issuer URLs consistently for discovery and client isolation. */
export function normalizeIssuer(issuer: string): string {
  return issuer.trim().replace(/\/+$/, "")
}

export async function fetchDiscovery(issuer: string): Promise<OIDCDiscovery> {
  const normalizedIssuer = normalizeIssuer(issuer)
  const cached = discoveryCache.get(normalizedIssuer)
  if (cached && Date.now() - cached.cachedAt < CACHE_TTL) {
    return cached.discovery
  }

  const url = `${normalizedIssuer}/.well-known/openid-configuration`
  const res = await fetch(url)
  if (!res.ok) {
    throw new Error(`Failed to fetch OIDC discovery: ${res.status} ${res.statusText}`)
  }

  const discovery: OIDCDiscovery = await res.json()
  discoveryCache.set(normalizedIssuer, { discovery, cachedAt: Date.now() })
  return discovery
}
